<fz-chip-group [scrollable]="scrollable()">
  @for (item of items() || []; track item.key) {
    <fz-chip
      [image]="item?.image"
      [label]="item.label"
      [matTooltip]="item?.tooltip"
      [highlighted]="selectedMap()[item.key] || false"
      (click)="toggleSelection(item.key)"
    />
  }
</fz-chip-group>
